// Humanises a trial-day count for end-user copy.
// 30 → "30 days", 90 → "3 months", 180 → "6 months", 365 → "1 year", 14 → "14 days"
export function formatTrialDuration(days) {
  const d = parseInt(days || 0, 10);
  if (!d) return "0 days";
  if (d >= 365 && d % 365 === 0) {
    const y = d / 365;
    return `${y} year${y === 1 ? "" : "s"}`;
  }
  if (d >= 60 && d % 30 === 0) {
    const m = d / 30;
    return `${m} month${m === 1 ? "" : "s"}`;
  }
  if (d >= 60) {
    const m = Math.round(d / 30);
    return `${m} months`;
  }
  return `${d} day${d === 1 ? "" : "s"}`;
}
